var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"background-color-seashell d-flex flex-1 px-3"},[_c('Nav',{attrs:{"fix":_vm.fix,"navTabs":_vm.navTabs}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }